import { ScaleInfo } from "custom-models/ViewerTypes";

import { ROIPosition, Subtype } from "shared/reducers/aiReducer";

const BASE_COLOR = "var(--richBlack)";

interface AIRegionProps {
  roi: ROIPosition;
  scaleInfo: ScaleInfo;
  pixelsPerMeter: number;
  isSelected?: boolean;
  type: string;
  subtype?: Subtype;
  color?: string;
}

export enum AIFeedback {
  UNDETERMINED = "UNDETERMINED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

const AIRegion = (props: AIRegionProps) => {
  let { scaleInfo, roi, pixelsPerMeter, color, type, subtype } = props;
  const point = {
    x: roi.center_point[0],
    y: roi.center_point[1],
  };
  const { radius, score } = roi;
  const scale = scaleInfo.scaleX;
  const fontSize = (size = 20) =>
    Math.min(
      Math.min(size / Math.min(scale, 1), 20000 * scale),
      size * 15 * (1 - scale)
    );

  return point && pixelsPerMeter ? (
    <g
      x={point.x}
      y={point.y}
      transform={`rotate(${-scaleInfo.rotation} ${point.x} ${point.y})`}
    >
      <defs>
        <filter
          x="0"
          y="0"
          width="1"
          height="1"
          id={`solid-${!!subtype?.diagnosis}-${subtype?.diagnosis_result}`}
        >
          <feFlood floodColor={color || BASE_COLOR} result="bg" />
          <feMerge>
            <feMergeNode in="bg" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle
        key="circle"
        cx={point.x}
        cy={point.y}
        r={radius}
        strokeWidth={3.0 / scale}
        stroke={color || BASE_COLOR}
        fill="transparent"
        className="AIAnnotationCircle"
      />
      <g
        filter={`url(#solid-${!!subtype?.diagnosis}-${
          subtype?.diagnosis_result
        })`}
      >
        <text
          x={point.x}
          y={
            point.y -
            radius -
            fontSize(20) / 4 -
            (subtype?.diagnosis ? fontSize(20) : 0)
          }
          textAnchor="start"
          style={{ fontSize: `${fontSize(20)}px` }}
          fill={
            color
              ? color === "var(--lightGrey)"
                ? "#666666"
                : "var(--black)"
              : "var(--lightGrey)"
          }
        >
          {type}&nbsp;
        </text>
        {subtype?.diagnosis && (
          <text
            x={point.x}
            y={point.y - radius - fontSize(16) / 4}
            textAnchor="start"
            style={{ fontSize: `${fontSize(16)}px` }}
            fill={
              color
                ? color === "var(--lightGrey)"
                  ? "#666666"
                  : "var(--black)"
                : "var(--lightGrey)"
            }
          >
            {subtype.diagnosis}&nbsp;
            {score && !Number.isNaN(score) && (
              <>
                (
                {subtype?.diagnosis_result === "INCONCLUSIVE" && (
                  <>Inconclusive &mdash; </>
                )}
                {score.toFixed(2)})
              </>
            )}
          </text>
        )}
      </g>
    </g>
  ) : null;
};

export default AIRegion;
